import type { IconDefinition } from '../index.tsx';

export const iconGift: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconGift',
  icon: [
    16,
    16,
    [],
    '',
    'M3 3V0H5C6.65685 0 8 1.34315 8 3C8 1.34315 9.34315 0 11 0H13V3H16V6H0V3H3Z M1 8H7V15H1V8Z M15 8H9V15H15V8Z',
  ],
};
